import React from 'react';
import {Basic} from './Basic.story';
import {List} from './List.story';
import {MultipleValues} from './MultipleValues.story';
import {Suggested} from './Suggested.story';
import {WithDropdown} from './WithDropdown.story';
import {NoClose} from './NoClose.story';

const basic = {
  rendered: <Basic />,
  source: `<ChipList>
  <Chip
    label="Currency"
    value="USD"
    onDropdown={() => {
      alert('Dropdown function triggered');
    }}
    onClose={() => {
      alert('Close function triggered');
    }}
  />
  <Chip
    label="Status"
    value="Succeeded"
    onDropdown={() => {
      alert('Dropdown function triggered');
    }}
    onClose={() => {
      alert('Close function triggered');
    }}
  />
  <Chip
    label="Amount"
    onAddSuggestion={() => {
      alert('Add Amount suggestion');
    }}
  />
  <Chip
    label="Date"
    onAddSuggestion={() => {
      alert('Add Date suggestion');
    }}
  />
</ChipList>`,
};

const list = {
  rendered: <List />,
  source: `<ChipList>
  <Chip
    label="Currency"
    value="USD"
    onDropdown={() => {
      alert('Dropdown function triggered');
    }}
    onClose={() => {
      alert('Close function triggered');
    }}
  />
  <Chip
    label="Status"
    value="Succeeded"
    onDropdown={() => {
      alert('Dropdown function triggered');
    }}
    onClose={() => {
      alert('Close function triggered');
    }}
  />
  <Chip
    value="jenny.rosen@stripe.com"
    onClose={() => {
      alert('Closed jenny.rosen');
    }}
  />
  <Chip
    value="usr_0As2kXSWDS1lTZsH5agB"
    onClose={() => {
      alert('Closed usr_0As2kXSWDS1lTZsH5agB');
    }}
  />
  <Chip
    label="Amount"
    onAddSuggestion={() => {
      alert('Add Amount suggestion');
    }}
  />
  <Chip
    label="Date"
    onAddSuggestion={() => {
      alert('Add Date suggestion');
    }}
  />
</ChipList>`,
};

const multipleValues = {
  rendered: <MultipleValues />,
  source: `<Chip
  label="Status"
  value={['Refunded', 'Succeeded']}
  onDropdown={() => {
    alert('Dropdown function triggered');
  }}
  onClose={() => {
    alert('Close function triggered');
  }}
/>`,
};

const suggested = {
  rendered: <Suggested />,
  source: `<Chip
  label="Date"
  onAddSuggestion={() => {
    alert('Suggestion function triggered');
  }}
/>`,
};

const withDropdown = {
  rendered: <WithDropdown />,
  source: `import {useState} from 'react';
import {Box, Chip} from '@sail/ui';

const WithDropdown = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Chip
        label="Status"
        value="Succeeded"
        onDropdown={() => setOpen(!open)}
        onClose={() => {
          alert('Close function triggered');
        }}
      />
      {open && (
        <Box
          css={{
            font: 'caption',
            borderRadius: 'medium',
            background: 'container',
            margin: 'small',
            padding: 'medium',
            color: 'secondary',
          }}
        >
          Dropdown contents
        </Box>
      )}
    </>
  );
};`,
};

const noClose = {
  rendered: <NoClose />,
  source: `<ChipList>
  <Chip label="Amount" value="$10" />
  <Chip
    label="Age"
    value="18-24"
    onDropdown={() => {
      alert('Dropdown function triggered');
    }}
  />
</ChipList>`,
};

export const ChipExamples = {
  basic,
  list,
  multipleValues,
  suggested,
  withDropdown,
  noClose,
};
